import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { CONTACT, SERVICES } from "../lib/data";

export const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-white/10 bg-[#070707]">
    <div className="mx-auto w-full max-w-7xl px-6 py-20 lg:px-10">
      <div className="grid gap-14 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link to="/" data-testid="footer-logo">
            <img
              src="/logo-full.png"
              alt="Logo YLBH Sumatera Timur — Berani, Peduli, Berintegritas"
              className="h-28 w-auto lg:h-32"
            />
          </Link>
          <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-[#A3A3A3]">
            Yayasan Bantuan Hukum yang berdiri sejak 2016. Menegakkan keadilan
            dan menjaga martabat setiap warga Sumatera, tanpa memandang status
            ekonomi.
          </p>
        </div>

        <div>
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold">
            Navigasi
          </h3>
          <ul className="mt-6 space-y-3">
            {[
              ["Beranda", "/"],
              ["Tentang Kami", "/tentang"],
              ["Direktori Kasus", "/kasus"],
              ["Personalia", "/tim"],
              ["Artikel", "/artikel"],
              ["Galeri", "/galeri"],
              ["Kontak", "/kontak"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-sm font-light text-[#C9C9C9] transition-colors hover:text-gold"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold">
            Layanan
          </h3>
          <ul className="mt-6 space-y-3">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link
                  to="/layanan"
                  className="text-sm font-light text-[#C9C9C9] transition-colors hover:text-gold"
                >
                  {s.judul}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold">
            Kantor
          </h3>
          <ul className="mt-6 space-y-4 text-sm font-light text-[#C9C9C9]">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-gold/70" />
              <span>{CONTACT.alamat}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="mt-0.5 shrink-0 text-gold/70" />
              <span className="flex flex-col gap-1">
                {CONTACT.telepon.map((n) => (
                  <a key={n} href={`tel:${n.replace(/\s/g, "")}`} className="whitespace-nowrap transition-colors hover:text-gold">
                    {n}
                  </a>
                ))}
              </span>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-0.5 shrink-0 text-gold/70" />
              <span>{CONTACT.email}</span>
            </li>
            <li className="flex gap-3">
              <Clock size={16} className="mt-0.5 shrink-0 text-gold/70" />
              <span>{CONTACT.jam}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className="overflow-hidden border-t border-white/10">
      <p
        aria-hidden="true"
        className="select-none whitespace-nowrap text-center font-serif text-[13vw] font-semibold leading-[0.85] text-white/[0.035]"
      >
        YLBH Sumatera Timur
      </p>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs font-light text-[#737373] sm:flex-row lg:px-10">
        <p>© 2026 YLBH Sumatera Timur. Seluruh hak cipta dilindungi.</p>
        <p className="italic">Fiat justitia ruat caelum — tegakkan keadilan walau langit runtuh.</p>
        <Link
          to="/admin/login"
          data-testid="footer-admin-link"
          className="transition-colors hover:text-gold"
        >
          Login Admin
        </Link>
      </div>
    </div>
  </footer>
);
